export const SIDEBAR_WIDTH = { expanded: 260, collapsed: 72 };

/** Collapsed mini-drawer geometry — single source for rail alignment. */
export const SIDEBAR_RAIL = {
  width: SIDEBAR_WIDTH.collapsed,
  itemSize: 36,
  iconSize: 20,
};

export const APP_SHELL_Z_INDEX = {
  mobileMenuButton: 1200,
  sidebarToggle: 1301,
  sidebarWrapper: 2,
};
